import client from './client';
import axios from 'axios';
import { getCookie, setCookie } from 'cookies-next';
import config from '../../config/configuration';
import { AppTypes, UserRefreshTokenWithCognitoResponseType } from '@zeus/shared';
import { endpoints } from './apiConfig';
import { cookieExpiryTime } from '../../config/constants';

client.interceptors.request.use((config) => {
  // Modify the request config
  const AccessToken = getCookie('AccessToken') || sessionStorage.getItem('AccessToken');
  if (AccessToken) {
    config.headers['Authorization'] = `Bearer ${AccessToken}`;
  }
  const IdToken = getCookie('IdToken') || sessionStorage.getItem('IdToken');
  if (IdToken) {
    config.headers['x-id-token'] = IdToken;
  }
  config.headers['x-app-name'] = AppTypes.ONLINE;

  if (config.url !== endpoints.auth.setUserAttributesUrl) {
    const tenantId = getCookie('selectedBusinessId');
    if (tenantId) {
      config.headers['x-tenant-id'] = tenantId;
    }
  }

  return config;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle API response errors
    const originalRequest = error.config;
    if (error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = getCookie('RefreshToken') || sessionStorage.getItem('RefreshToken');
      const sub = getCookie('sub') || sessionStorage.getItem('sub');

      const headers = {
        Authorization: getCookie('AccessToken') || sessionStorage.getItem('AccessToken'),
        'x-id-token': getCookie('IdToken') || sessionStorage.getItem('IdToken'),
        'x-app-name': AppTypes.ONLINE,
        'x-tenant-id': getCookie('selectedBusinessId'),
      };
      return axios
        .post(
          `${config.BASE_URL}authentication/refresh-token`,
          {
            refreshToken: refreshToken,
            sub: sub,
          },
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.status === 200) {
            const data: UserRefreshTokenWithCognitoResponseType = res.data;
            const accessToken = data.data?.AuthenticationResult?.AccessToken ?? '';
            const refreshToken = data.data?.AuthenticationResult?.RefreshToken ?? '';
            const IdToken = data.data?.AuthenticationResult?.IdToken ?? '';
            const cookieOptions = { maxAge: cookieExpiryTime }; // 30 days
            setCookie('AccessToken', accessToken, cookieOptions);
            setCookie('IdToken', IdToken, cookieOptions);
            if (refreshToken) {
              setCookie('RefreshToken', refreshToken, cookieOptions);
            }
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken;
            originalRequest.headers['Authorization'] = 'Bearer ' + accessToken;
            return axios(originalRequest);
          }
        });
    }
    return Promise.reject(error);
  }
);
export default client;
